"use strict";

import cookieService from "./cookie-service.js";
import { COOKIE_NAMES } from "../Constants/cookies.js";

const dataLayerService = (() => {
    let dataLayer;

    /**
     * Shared GA4 event names. Keep event-name strings here so every module pushes the same
     * value and no module repeats the literal.
     */
    const EVENTS = {
        AI_SEARCH_OPEN: "ai_search_open"
    };

    /**
     * Initializes the dataLayer. Should be called once.
     */
    const init = () => {
        dataLayer = window.dataLayer = window.dataLayer || [];
    };

    /**
     * Reads the visitor id from its cookie. This is the per-visitor analytics id, present for
     * anonymous and signed-in users alike.
     * @returns {string} The visitor id, or "" when the cookie is not set.
     */
    const getVisitorId = () => cookieService.getCookie(COOKIE_NAMES.VISITOR_ID) || "";

    /**
     * Pushes an event with associated data to dataLayer.
     * @param {string} eventName - The event name.
     * @param {string} key - The dataLayer key.
     * @param {*} value - The value to associate with the key.
     */
    const pushEvent = (eventName, key, value) => {
        const data = {
            event: eventName
        };
        data[key] = value;
        if (dataLayer) {
            dataLayer.push(data);
        } else {
            console.warn('DataLayer Service not initialized.');
        }
    };

    const pushEventWithData = (eventName, dataObject) => {
        const data = {
            event: eventName,
            ...dataObject
        };
        if (dataLayer) {
            dataLayer.push(data);
        } else {
            console.warn('DataLayer Service not initialized.');
        }
    };

    init();

    return {
        EVENTS,
        getVisitorId,
        pushEvent,
        pushEventWithData
    };
})();

if (typeof window !== "undefined" && !window.dataLayerService) {
    window.dataLayerService = dataLayerService;
}

export default dataLayerService;